


const partypooper = {
    logo: require("../imgs/partyPopper/logo.png"),
    screen1: require("../imgs/partyPopper/screen1.png"),
    screen2: require("../imgs/partyPopper/screen2.png"),
    screen3: require("../imgs/partyPopper/screen3.png"),
    screen4: require("../imgs/partyPopper/screen4.png"),
    screen5: require("../imgs/partyPopper/screen5.png"),
    screen6: require("../imgs/partyPopper/screen6.png"),
}

const pushcounter = {
    logo: require("../imgs/pushupcounter/logo.png"),
    screen1: require("../imgs/pushupcounter/screen1.png"),
    screen2: require("../imgs/pushupcounter/screen2.png"),
    screen3: require("../imgs/pushupcounter/screen3.png"),
    screen4: require("../imgs/pushupcounter/screen4.png"),
    screen5: require("../imgs/pushupcounter/screen5.png"),
    screen6: require("../imgs/pushupcounter/screen6.png"),
    screen7: require("../imgs/pushupcounter/screen7.png")
}




const pettranslator={
    logo: require('../imgs/petTranstalor/logo.png'),
    screen1: require('../imgs/petTranstalor/screen1.png'),
    screen2: require('../imgs/petTranstalor/screen2.png'),
    screen3: require('../imgs/petTranstalor/screen3.png'),
    screen4: require('../imgs/petTranstalor/screen4.png'),
    screen5: require('../imgs/petTranstalor/screen5.png'),
    screen6: require('../imgs/petTranstalor/screen6.png'),
    screen7: require('../imgs/petTranstalor/screen7.png'),
}

const phonefinder={
    logo: require('../imgs/findmyPhone/logo.png'),
    screen1: require('../imgs/findmyPhone/screen1.png'),
    screen2: require('../imgs/findmyPhone/screen2.png'),
    screen3: require('../imgs/findmyPhone/screen3.png'),
    screen4: require('../imgs/findmyPhone/screen4.png'),
    screen5: require('../imgs/findmyPhone/screen5.png'),
    screen6: require('../imgs/findmyPhone/screen6.png'),
    screen7: require('../imgs/findmyPhone/screen7.png'),
}

const hairclippersimulator={
    logo: require('../imgs/hairClipper/logo.png'),
    screen1: require('../imgs/hairClipper/screen1.png'),
    screen2: require('../imgs/hairClipper/screen2.png'),
    screen3: require('../imgs/hairClipper/screen3.png'),
    screen4: require('../imgs/hairClipper/screen4.png'),
    screen5: require('../imgs/hairClipper/screen5.png'),
    screen6: require('../imgs/hairClipper/screen6.png'),
}

const flashalertsoncallandmessage={
    logo: require('../imgs/FlashAlerts/logo.png'),
    screen1: require('../imgs/FlashAlerts/screen1.png'),
    screen2: require('../imgs/FlashAlerts/screen2.png'),
    screen3: require('../imgs/FlashAlerts/screen3.png'),
    screen4: require('../imgs/FlashAlerts/screen4.png'),
    screen5: require('../imgs/FlashAlerts/screen5.png'),
    screen6: require('../imgs/FlashAlerts/screen6.png'),
    screen7: require('../imgs/FlashAlerts/screen7.png'),
}

const screenprank={
    logo: require('../imgs/screenPrank/logo.png'),
    screen1: require('../imgs/screenPrank/screen1.png'),
    screen2: require('../imgs/screenPrank/screen2.png'),
    screen3: require('../imgs/screenPrank/screen3.png'),
    screen4: require('../imgs/screenPrank/screen4.png'),
    screen5: require('../imgs/screenPrank/screen5.png'),
    screen6: require('../imgs/screenPrank/screen6.png'),
}

const displayInfo={
    logo: require('../imgs/displayInfo/logo.png'),
    screen1: require('../imgs/displayInfo/screen1.png'),
    screen2: require('../imgs/displayInfo/screen2.png'),
    screen3: require('../imgs/displayInfo/screen3.png'),
    screen4: require('../imgs/displayInfo/screen4.png'),
    screen5: require('../imgs/displayInfo/screen5.png'),
    screen6: require('../imgs/displayInfo/screen6.png'),
    screen7: require('../imgs/displayInfo/screen7.png'),
}

const cuemotion={
    logo: require('../imgs/cueMotion/logo.png'),
    screen1: require('../imgs/cueMotion/screen1.png'),
    screen2: require('../imgs/cueMotion/screen2.png'),
    screen3: require('../imgs/cueMotion/screen3.png'),
    screen4: require('../imgs/cueMotion/screen4.png'),
    screen5: require('../imgs/cueMotion/screen5.png'),
    screen6: require('../imgs/cueMotion/screen6.png'),
    
}



export { partypooper, pushcounter,  pettranslator,  phonefinder,hairclippersimulator,flashalertsoncallandmessage, screenprank, displayInfo, cuemotion}
